import { Stack } from '@mui/material';
import { IntegrationsContainer } from '../IntegrationsContainer';
import { IntegrationsHeader } from '../IntegrationsHeader';

export const Integrations = () => {
  return (
    <Stack>
      <IntegrationsHeader />
      <IntegrationsContainer />
    </Stack>
  );
};
